export const getChannelContent = channelData => ({
  title: channelData.title,
  description: channelData.description,
  coverUrl: channelData.customCoverUrl || channelData.coverUrl
});
export const getVideoContent = videoItem => ({
  title: videoItem.title,
  description: videoItem.description,
  coverUrl: videoItem.customCoverUrl || videoItem.coverUrl
});
//# sourceMappingURL=content.js.map